import React, { useEffect, useState } from "react";
import api from "../api/api";
import { Helmet } from "react-helmet";
import Spinner from "../components/Spinner";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaTint, FaSun, FaWind, FaCloudRain } from "react-icons/fa";
import { WiTime3, WiHumidity } from "react-icons/wi";
import { GiSpeedometer, GiRadiations } from "react-icons/gi";
import { TiWaves } from "react-icons/ti";

function TodayIrrigation() {
  const [irrigation, setIrrigation] = useState(null);
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchToday = async () => {
      try {
        const res = await api.get("/irrigation/today");
        setIrrigation(res.data.irrigation);
        setWeather(res.data.weather);
      } catch (err) {
        console.error("Failed to fetch today's irrigation:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchToday();
  }, []);

  if (loading) return <Spinner />;

  if (!weather) {
    return (
      <Container className="py-5">
        <h4>Weather data is temporarily unavailable.</h4>
      </Container>
    );
  }

  if (!irrigation) {
    return (
      <Container className="py-5">
        <h4>No irrigation calculated for today.</h4>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>LCWE | Today's Irrigation</title>
      </Helmet>

      <Container className="py-5">
        <Row className="mb-4">
          <Col>
            <h4>
              Hello, your <strong>{irrigation.crop_name}</strong>
            </h4>

            {irrigation.irrigation_liters > 0 ? (
              <p>
                You have to irrigate{" "}
                <strong>
                  {irrigation.irrigation_liters.toFixed(2)} Liters
                </strong>{" "}
                today.
              </p>
            ) : (
              <p>There is no need to irrigate today.</p>
            )}
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Card className="info-card blue-card">
              <Card.Body>
                <h5>Today's Irrigation</h5>
                <h1>
                  <FaTint /> {irrigation.irrigation_liters.toFixed(2)} L
                </h1>
                <p>
                  <WiTime3 /> Date:{" "}
                  {new Date(irrigation.irrigation_date).toLocaleString()}
                </p>
                <p>Field Area: {irrigation.area_m2.toFixed(2)} m²</p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="info-card green-card">
              <Card.Body>
                <h5>Live Weather</h5>
                <h1>
                  <FaSun /> {weather.temperature.toFixed(2)}°C
                </h1>
                <p>
                  <FaWind /> Wind: {weather.wind_speed.toFixed(2)} m/s
                </p>
                <p>
                  <WiHumidity /> Humidity: {weather.humidity.toFixed(2)}%
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <Card className="small-card">
              <Card.Body>
                <h6><TiWaves /> Soil Moisture</h6>
                <h3>{(weather.soil_moisture * 100).toFixed(2)}%</h3>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card className="small-card">
              <Card.Body>
                <h6><GiRadiations /> Solar Radiation</h6>
                <h3>{Number(weather.solar_radiation).toFixed(2)}</h3> 
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card className="small-card">
              <Card.Body>
                <h6><GiSpeedometer /> Pressure</h6>
                <h3>{weather.pressure.toFixed(2)}</h3>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card className="small-card">
              <Card.Body>
                <h6><FaCloudRain /> Rainfall</h6>
                <h3>{weather.rainfall.toFixed(2)} mm</h3>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TodayIrrigation;


{/* <Row className="mt-3 align-items-center justify-content-center">
          <Col md={5}>
            <Card className="small-card crop-card">
              <Card.Body>
                <h5><FaStar /> Recommended Crops</h5>
                <div className="crops">
                  <span>🌽 Corn</span>
                  <span>🍅 Tomato</span>
                  <span>🥬 Lettuce</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
